/**
 * Time In Force
 */
import {SwitchState} from '../components/switch';

export enum TimeInForce {

    /** GTC */
    GTC = 'GTC',

    /** Immediate or Cancel */
    IOC = 'IOC'
}

export const TIME_IN_FORCE_SWITCH_CONFIG: SwitchState[] = [
    {
        label: 'enums.time-in-force.switch_gtc',
        value: TimeInForce.GTC
    },
    {
        label: 'enums.time-in-force.switch_ioc',
        value: TimeInForce.IOC
    }
];
